import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth'
import HomePage from '@/pages/HomePage'
import LoginPage from '@/pages/LoginPage'
import FormPage from '@/pages/FormPage'
import ReportPage from '@/pages/ReportPage'
import AdminPage from '@/pages/AdminPage'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/',
			name: 'HomePage',
			component: HomePage
		},
		{
			path: '/login',
			name: 'LoginPage',
			component: LoginPage,
			props: {registration:false}
		},
		{
			path: '/signup',
			name: 'SignupPage',
			component: LoginPage,
			props: {registration:true}
		},
		{
			path: '/form',
			name: 'FormPage',
			component: FormPage
		},
		{
			path: '/report',
			name: 'ReportPage',
			component: ReportPage
		},
		{
			path: '/logout',
			name: 'HomePage',
			component: HomePage
		},
		{
			path: '/admin',
			name: 'AdminPage',
			component: AdminPage
		}
	]
})

router.afterEach((to, from) => {
	if (to.path == "/logout") {
		console.log("RESET LOGIN")
		auth.signout()
	}
})

export default router